import { Button } from "antd";
import TimeDown from "../../components/timedown/timedown";
import styles from "./ListView.module.scss";
import { complexDigitToman } from "../../tools/tools";
import { _adr } from "../../address";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
const ListView = ({ item }) => {
  const nav = useNavigate();
  const Holder_Button = styled.div`
    margin-top: 0 !important;
  `;
  const switchTagBag = (type = 0) => {
    switch (type) {
      case 0:
        return "gold";
      case 1:
        return "platinum";
      case 2:
        return "silver";
      case 3:
        return "bronze";
      case 4:
        return "aptel";
      default:
        return "";
    }
  };
  return (
    <>
      <div className={styles.showpackageglobal}>
        <div className={styles.itemnumber}>
          <div className={styles.rowitem} data-title={item.auctionProductType} data-type={switchTagBag(item?.auctionProductTypeiId)}>
            <div className={styles.msisdn_hold} data-type={switchTagBag(item?.auctionProductTypeiId)}>
              <div className={styles.tagName}>{item?.auctionProductType}</div>
              <div className={styles.number}>
                <h2>{item?.auctionTitle}</h2>
                <span>{item?.bundle?.bundleName}</span>
              </div>
            </div>
            <div className={styles.holder_split}>
              <div className={styles.prefer}>
                <span>بالاترین پیشنهاد</span>
                <div className={styles.price}>
                  <span dir="ltr">{complexDigitToman(item?.maxBid)}</span> تومان
                </div>
              </div>
              <div className={styles.startPrice}>
                <span>قیمت شروع</span>
                <div className={styles.price}>
                  <span dir="ltr">{complexDigitToman(item?.startPrice)}</span> تومان
                </div>
              </div>
            </div>
            <div className={styles.timeAction}>
              {item?.userBid > 0 ? (
                <>
                  <div className={styles.priceBide}>
                    <span>قیمت پیشنهادی شما</span>
                    <div className={styles.price}>
                      <span dir="ltr">{complexDigitToman(item?.userBid)}</span> تومان
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.timer}>
                    <h3 className={styles.title}>مهلت شرکت در حراجی:</h3>
                    <TimeDown datetime={new Date(item?.endDate)} />
                  </div>
                </>
              )}

              <div className={styles.action}>
                <Holder_Button className={`holder-button ${styles.holder_button}`}>
                  <Button
                    className={`btn-normal ${styles.btnNormal}`}
                    onClick={(e) => nav(_adr.Root + _adr.Landing.Index + _adr.Landing.Details + `?id=${item?.auctionProductId}`)}
                  >
                    <span className={styles.mobile}>مشاهده جزئیات و ارائه پیشنهاد</span>
                    <span className={styles.desktop}>جزئیات</span>
                  </Button>
                </Holder_Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListView;
